import React, { Component } from 'react';
import Input from '../component/Input.js';
import SelectBox from '../component/Select.js';
import Validation from './Validation.js';

export default class CurrentASMEdit extends Component {
	constructor(props){
		super(props);
		this.handleInput = this.handleInput.bind(this);
		this.commitChanges = this.commitChanges.bind(this);
		this.state = {prize:'',tier:'',price:'',quantity:0,threshold:'',picture:'',description:'',status:'',finish:false,invalid:false,invalidFields:''};
	}

	componentDidMount(){ //set state with current prize values so that inputs contain current values by default
		let p = this.props.prize;
		this.setState({prize:p.prize,tier:p.tier,price:Number(p.price).toFixed(2),threshold:Number(p.threshold),picture:p.picture,description:p.description,status:p.status});
	}

	handleInput(identity,value){ //standard method for handling user input
		const theState = this.state;
		theState[identity] = value;
		this.setState(theState);
	}

	commitChanges(){ //method to begin process of updating prize info. eventually, all code in componentDidUpdate should be moved here
		this.setState({finish:true});
	}

	componentDidUpdate(prevProps,prevState){
		if(this.state.finish !== prevState.finish && this.state.finish){ //if user has chosen to update prize with the current information
			const {prize,tier,price,description,quantity,threshold,status} = this.state;
			if(Validation("prize",prize.trim()) && Validation("prize",description.trim()) && prize.trim() !== '' && description.trim() !== '' && price.trim() !== '' && price.trim() !== '.' && threshold !== ''){ //if all fields are filled out and contain valid input, pass up state to parent (EditASMPrize)
				this.setState({invalid:false});
				let qty = quantity === ''?0:quantity;
				this.props.onFinish({ID:this.props.prize.prizeID,prize:prize.trim(),tier:tier,price:price,description:description.trim(),threshold:threshold,quantity:qty,status:status});
			}else{ //one or more input fields is blank or invalid
				let invalidField;
				if((!Validation("prize",prize.trim())||prize.trim() === '') && (!Validation("prize",description.trim())||description.trim() === '')){
					invalidField = 'both';
				}else if(!Validation("prize",prize.trim()) || prize.trim() === ''){
					invalidField = 'prize';
				}else if(!Validation("prize",description.trim()) || description.trim() === ''){
					invalidField = 'description';
				}
				if(threshold === ''){
					document.getElementById("threshold").classList.add("invalid");
				}else{
					document.getElementById("threshold").classList.remove("invalid");
				}
				if(price.trim() === '' || price.trim() === '.'){
					document.getElementById("price").classList.add("invalid");
				}else{
					document.getElementById("price").classList.remove("invalid");
				}
				this.setState({finish:false,invalid:true,invalidFields:invalidField});
			}
		}
	}

	render(){
		let invalidMessage;
		const inputStyles = "pa0 h2 br2 bw1 w-100 shadow-2 pl2";
		let areaStyles="pa0 br2 bw1 h3 w-100";
		let prizeStyles = inputStyles;
		if(this.state.invalid){ //error message and highlighting for invalid or empty input fields
			invalidMessage = <span className="b red">*All fields must be filled out and valid</span>;
			if(this.state.invalidFields === 'both'){
				areaStyles="pa0 b--red br2 bw1 h3 w-100";
				prizeStyles = "pa0 h2 b--red br2 bw1 w-100 shadow-2 pl2";
			}else if(this.state.invalidFields === 'prize'){
				prizeStyles = "pa0 h2 b--red br2 bw1 w-100 shadow-2 pl2";
			}else if(this.state.invalidFields === 'description'){
				areaStyles="pa0 b--red br2 bw1 h3 w-100";
			}
		}
		const buttonStyles ="br3 white b w-30-ns w-60-m w-100 h2 bg-navy shadow-2";
		return(
			<div className="fl w-100" style={{maxWidth:'800px',margin:'auto'}}>
				{invalidMessage}
				<div className="fl w-100">
					<div className="fl w-50-ns w-100 pa2">
						<div className="fl w-100">
							<label className="b navy mb1">Prize name: </label>
						</div>
						<div className="fl w-100">
							<Input identity="prize" onInput={this.handleInput} val={this.state.prize} inputStyle={prizeStyles}/>
						</div>
					</div>
					<div className="fl w-25-ns w-100 pa2">
						<div className="fl w-100">
							<label className="b navy tr mb1">Tier: </label>
						</div>
						<div className="fl w-100">
							<SelectBox name="tier" identity="tier" onSelect={this.handleInput} options={this.props.tiers} styles={inputStyles} val={this.state.tier}/>
						</div>
					</div>
					<div className="fl w-25-ns w-100 pa2">
						<div className="fl w-100">
							<label className="b navy tr mb1">Price: </label>
						</div>
						<div className="fl w-100">
							<Input identity="price" id="price" onInput={this.handleInput} val={this.state.price} inputStyle={inputStyles} type="number"/>
						</div>
					</div>
				</div>
				<div className="fl w-100 mt3">
					<div className="fl w-75-ns w-100-m w-100">
						<div className="fl w-50-ns w-100 pa2">
							<div className="fl w-100">
								<label className="b navy tr mb1">Notification Threshold: </label>
							</div>
							<div className="fl w-100">
								<Input identity="threshold" id="threshold" onInput={this.handleInput} val={this.state.threshold} inputStyle={inputStyles} type="number"/>
							</div>
						</div>
						<div className="fl w-50-ns  w-100 pa2">
							<div className="fl w-100">
								<label className="b navy tr mb1">Quantity To Add: </label>
							</div>
							<div className="fl w-100">
								<Input identity="quantity" onInput={this.handleInput} val={this.state.quantity} inputStyle={inputStyles} type="number"/>
							</div>
						</div>
					</div>
					<div className="fl w-25-ns w-100-m w-100 pa2">
						<div className="fl w-100">
							<label className="b navy tr mb1">Status: </label>
						</div>
						<div className="fl w-100">
							<SelectBox identity="status" onSelect={this.handleInput} val={this.state.status} options={["active","inactive","Discontinued"]} styles={inputStyles}/>
						</div>
					</div>
				</div>
				<div className="fl w-100 mt3 pa2">
						<div className="fl w-100">
							<label className="mb1 b navy mb1">Description: </label>
						</div>
						<div className="fl w-100">
							<Input type="text" identity="description" inputStyle={inputStyles} onInput={this.handleInput} val={this.state.description}/>
						</div>
					</div>
				<div className="fl w-100 tc mt2">
					<button onClick={this.commitChanges} className={buttonStyles}>Save Changes</button>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/CurrentASMEdit.js